import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '../Input/Input';
import { ToggleCheckbox } from '../ToggleCheckbox/ToggleCheckbox';
import { termsConfirmationText, termsSource } from '../../pages/register';

export default function Three() {
	const { errors, control } = useFormContext();

	return (
		<div className='flex flex-col gap-4'>
			<h1 className='text-3xl mt-4 leading-tight font-light w-full'>
				Let's get you hiring!
			</h1>
			<Controller
				name='jobTitle'
				control={control}
				rules={{
					required: 'Please enter the title of the role you wish to hire for',
				}}
				render={props => {
					return (
						<Input
							type='text'
							onChange={props.onChange}
							nullable={false}
							error={errors?.jobTitle?.message}
							label='What role are you hiring for?'
							value={props.value}
							name='jobTitle'
							tooltip='To get you hiring as quickly as possible, we will create your first job for you and show you the ropes. You can change the title of this role and create additional roles later.'
							placeholder='Sales executive'
							required
						/>
					);
				}}
			/>
			<Controller
				name='termsConfirmed'
				control={control}
				render={props => (
					<ToggleCheckbox
						label={termsConfirmationText}
						onClick={props.onChange}
						name='termsConfirmed'
						value={props.value}
						inline
						grey
						required
						extraClasses='my-2'
					/>
				)}
			/>
			<a
				href={termsSource}
				target='_blank'
				rel='noreferrer'
				className='underline'
			>
				View terms & conditions
			</a>
		</div>
	);
}
